import { formatNumber } from "./format-number";

export const formatPercentage = ({
    percentage,
    decimals,
}: {
    percentage: number;
    decimals: number;
}): { percentageStringIntegerPart: string; percentageStringDecimalPart: string | null } => {
    const formattedPercentage = formatNumber(percentage, {
        numDecimals: decimals,
    });
    const [integerPart, decimalPart] = formattedPercentage.split(".");

    const hasNonZeroDecimals = decimalPart && Number(decimalPart) !== 0;

    return {
        percentageStringIntegerPart: integerPart!,
        percentageStringDecimalPart: hasNonZeroDecimals ? decimalPart : null,
    };
};
